import * as pdfjsLib from 'pdfjs-dist';

const isProduction = import.meta.env.PROD;

const baseUrl = window.location.origin;
const workerSrc = isProduction 
  ? `${baseUrl}/pdf.worker/pdf.worker.min.mjs` 
  : new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

pdfjsLib.GlobalWorkerOptions.workerPort = null;

export { pdfjsLib }; 